import { useContext } from "react";
import { Navigate } from "react-router-dom";
import instance from "../utils/axios";
import ActionContext from "../context/ActionContext";
import { toast } from "../components/razor-reuse";

export const LOGOUT = async () => {
  localStorage.clear();
};

const PrivateRouteDashboard = ({ children }: any) => {
  const actionCtx = useContext(ActionContext);

  instance.interceptors.response.use(
    async (response: any) => {
      if (
        response?.response?.data?.message === "Requested resource is not found"
      ) {
        actionCtx?.setSessionEnd?.(true);
        return;
      }

      if (
        response?.response?.data?.message === "This action is unauthorized."
      ) {
        toast.error(response?.response?.data?.message);
        return;
      }
      if (response?.response?.data?.status === "failed") {
        if (
          response?.response?.data?.message ===
            "Unauthenticated. Please login to proceed" ||
          response?.response?.data?.message === "Unauthenticated."
        ) {
          actionCtx?.setSessionEnd && actionCtx?.setSessionEnd(true);
          return;
        }

        return;
      }
      return response;
    },
    async (error: any) => {
      //   console.log(error, "------------");
      if (error?.response?.data?.status === "failed") {
        if (
          error?.response?.data?.message ===
          "Unauthenticated. Please login to proceed"
        ) {
          actionCtx?.setSessionEnd && actionCtx?.setSessionEnd(true);
          return;
        }

        if (error?.response?.data?.error?.message) {
          //   const genMsg = error?.response?.data?.error?.message;
          //   toast.error(genMsg as any);
        }

        if (Object?.values(error?.response?.data?.errors)[0]) {
          //   const msg = Object?.values(error?.response?.data?.errors)[0];
          //   toast.error(msg as any);
        }

        return;
      }
      if (error?.response?.status === 422) {
        // toast.error(`${error?.response?.data?.message}`, {
        //   theme: "colored",
        //   // toastId: customErrorId,
        // });
        //   console.log(error);
        return error;
      }
      if (error?.response?.status !== 401) {
    
        return error;
      }
      if (
        error?.response?.status === 401 &&
        error?.response?.data?.message === "Not authorized!"
      ) {
        return error;
      }
      return error;
    }
  );

  const authenticated = localStorage.getItem("token");

  return authenticated ? children : <Navigate to="/login" />;
};

export default PrivateRouteDashboard;
